import { JT } from "./jumbotronTokens";

// Presentational: the giant status word behind the card content (at-a-glance signal).
// Clipped by the card's overflow:hidden. Never interactive.
export default function StatusWatermark({ label, color }) {
  return (
    <div aria-hidden="true" data-testid="status-watermark" style={{
      ...JT.display900, position:"absolute", top:-16, right:-4,
      fontSize:76, lineHeight:1, color, opacity:0.07,
      pointerEvents:"none", userSelect:"none", whiteSpace:"nowrap",
    }}>{label}</div>
  );
}
